import { DatePicker, Select, Skeleton } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";
import { ColumnChart, FilterBar } from "./chartUtils";
dayjs.extend(customParseFormat);

const { Option } = Select;

function BugByMonth({ projects }) {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [barChartData, setbarChartData] = useState([]);
    const [defaultYear, setDefaultYear] = useState(dayjs());
    const [assignee, setAssignee] = useState([]);
    const [formData, setFormData] = useState({
        staff_id,
        range_year: dayjs().get("year"),
        project_id: -1,
    });

    const {
        status: assigneeStatus,
        data: assigneeRes,
        refetch: fetchWorkLogAuthor,
    } = useQuery(
        "assignee",
        async () => await HTTP("/analytics/getJiraAssignees", { staff_id }),
        { enabled: false },
    );

    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "bugByMonths",
        async () =>
            await HTTP("/analytics/getJiraBugsByMonth", { ...formData }),
        { enabled: false },
    );

    useEffect(() => {
        getChart();
        fetchWorkLogAuthor();
    }, []);
    useEffect(() => {
        getChart();
    }, [formData]);

    useEffect(() => {
        if (assigneeStatus === "success") setAssignee(assigneeRes.data);
    }, [assigneeStatus, assigneeRes]);

    useEffect(() => {
        if (chartStatus === "success") setbarChartData(chartRes.data);
    }, [chartStatus, chartRes]);

    function handleYearChange(_, dateString) {
        setDefaultYear(dateString === "" ? dayjs() : dayjs(dateString));
        setFormData((prev) => ({
            ...prev,
            range_year: dateString || dayjs().get("year"),
        }));
    }

    function handleProjectSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            project_id: e ? e.split("#")[0] : -1,
        }));
    }

    function handleAssigneeSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            workauthor_id: e ? e.split("#")[0] : "",
        }));
    }

    const isReady = chartStatus !== "loading" && chartStatus !== "idle";

    return (
        <>
            <FilterBar>
                <DatePicker
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                    style={{ width: 120 }}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Work-log Author"
                    onChange={handleAssigneeSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </FilterBar>
            {isReady && barChartData.length > 0 ? (
                <ColumnChart rawData={barChartData} height={420} stacked />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 10, width: "100%" }}
                />
            )}
        </>
    );
}

export default BugByMonth;
